export const enum RivetIntegrationStatus {
  NOT_CONNECTED = "notConnected",
  CONNECTED = "connected",
}